import React, { useState, useRef, useEffect } from 'react';
import Footer from '../components/Footer';
import safetyLogo from '../images/logo_safety100_mice.svg';
import {useNavigate} from 'react-router-dom';
import * as securityHelper from "../helper/SecurityHelper";
import { fn_loginHandlerCallback } from '../api/FnCmmn'
import Snackbar from '../components/Snackbar';
import { MdLanguage } from "react-icons/md";

const $ = require("jquery")

export default function Login() {
    const navigate = useNavigate();
    const [snackbarTxt, setSnackbarTxt] = useState('');
    const user = securityHelper.getLoginUser();

    useEffect(() => { snackbarTxt && setTimeout(() => setSnackbarTxt(''), 2000) }, [snackbarTxt]);

    const firstStepHandler = () => {
        navigate('/signUp')
    }
    const toForeignerPage = () => {
        navigate('/foreigner', { state : { doneTbm : false }});
    }

    useEffect(() => {
        // 보안 업데이트 마이그레이션: 잔존 localStorage 정리
        // 토스트는 실제 세션이 남아있던 경우(USER_SESSION)에만 띄움
        const legacyKeys = ['USER_SESSION', 'USER_ID', 'SAVE_USER_ID', 'hideModalDate'];
        const hadSession = localStorage.getItem('USER_SESSION') !== null;
        legacyKeys.forEach(k => localStorage.removeItem(k));

        // 토스트 우선순위: 401 세션 만료 안내 > 마이그레이션 안내
        const flash = sessionStorage.getItem('FLASH_SNACK');
        if (flash) {
            sessionStorage.removeItem('FLASH_SNACK');
            setSnackbarTxt(flash);
        } else if (hadSession) {
            setSnackbarTxt('보안 업데이트로 인해 다시 로그인이 필요합니다.');
        }

        if (user) {
            fn_loginHandlerCallback(user, navigate);
        }

        // 아이디 불러오기
        let USER_ID = sessionStorage.getItem("USER_ID");
        if (USER_ID !== null) {
            // setUserId(USER_ID);
            // setIsRemember(true);
        }
    }, [])

    return (
        <div className='w-screen h-[calc(100dvh)] flex flex-col items-center relative'>
            {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
            <div className='flex flex-col items-center justify-center'>
                <img className='mb-[7.5rem] md:mb-[240px] mt-[33%] md:mt-[247px] w-[65%] md:w-[487px]' src={safetyLogo}
                     alt='logo'/>
                <div className='w-[70%] md:w-[600px]'>
                    <p className='text-21 font-preLight md:text-40'>사고 예방을 위한</p>
                    <p className='text-21 font-preLight md:text-40 mt-[0.5rem]'>작업 전 안전교육 (TBM)</p>
                    <p className='text-21 font-preLight md:text-40 mt-[0.5rem]'>안전을 위한 한 걸음</p>
                    <Btn clickHandler={firstStepHandler} login>시작하기</Btn>
                </div>
            </div>
            <div className='relative h-screen w-screen'>
                <div onClick={toForeignerPage}
                     className='absolute z-[1000] bottom-40 text-21 md:text-40 left-[50%] translate-x-[-50%] flex'>
                    <MdLanguage className='translate-y-5 mr-5 text-[#00FFFF]'/><span
                    className='font-preLight'>foreigner</span></div>
            </div>
            <Footer/>
        </div>
    );
}

const Btn = ({login, signUp, clickHandler, children}: any) => {
    return (
        <button
            className={`md:mt-[75px] text-20 md:text-37 leading-18 md:leading-36 w-full py-[0.7rem] md:py-[30px] outline-none rounded-[5px] md:rounded-[12px]
            ${login ? 'mt-[1.4rem] bg-gradient-to-r from-gdFrom to-gdTo' : signUp ? 'mt-[0.8rem] bg-gradient-to-r from-gdNfcFrom to-gdNfcTo' : 'mt-[0.8rem] bg-[#585959]'}`}
            onClick={clickHandler}>{children}</button>
    );
};

// const [validArea, setValidArea] = useState(true);
// const userPhoneReference = useRef<any>(null);
// const passwordReference = useRef<any>(null);
// const [isUser, setIsUser] = useState(false);
// const [userId, setUserId] = useState('');
// const [isRemember, setIsRemember] = useState(false);

// const BackBtn = ({ clickHandler }: any) => {
//     return (
//         <button
//             className='mt-[1.25rem] md:mt-[50px] font-preLight text-13 md:text-32 leading-18 md:leading-36 w-full py-[0.5rem] md:py-[30px] outline-none bg-gradient-to-r from-gdNfcFrom to-gdNfcTo rounded-[5px] md:rounded-[12px]'
//             onClick={clickHandler}>다시입력</button>
//     );
// };
//
// const NfcBtn = ({ clickHandler }: any) => {
//     return (
//         <button
//             className='mt-[1.25rem] md:mt-[50px] font-preLight text-13 md:text-32 leading-18 md:leading-36 w-full py-[0.5rem] md:py-[30px] outline-none bg-gradient-to-r from-gdNfcFrom to-gdNfcTo rounded-[5px] md:rounded-[12px]'
//             onClick={clickHandler}>NFC태깅</button>
//     );
// };

// envHelper.getEnv(function (data: any) {
//     // setPccReqinfo(data.PCC_REQINFO)
//     // setPccReturl(data.PCC_RETURL)
//     // setPccVersion(data.PCC_VERSION)
//     $.ajax({
//         url: "https://t1.kakaocdn.net/kakao_js_sdk/2.1.0/kakao.min.js",
//         dataType: 'script',
//         async: false
//     }).done(function () {
//         // @ts-ignore
//         Kakao.init(data["KAKAO_SERVICE_KEY"]);
//         var search = document.location.search
//         // @ts-ignore
//         if (search && search.indexOf("code=") > -1) {
//             // kakao 콜백 판단
//             var code = search.split("=")[1]
//             axios.post('https://kauth.kakao.com/oauth/token', {
//                 grant_type: "authorization_code",
//                 client_id: data["KAKAO_SERVICE_KEY"],
//                 redirect_uri: redirectUri,
//                 code: code
//             }, {
//                 headers: {
//                     "Content-type": "application/x-www-form-urlencoded;charset=utf-8"
//                 }
//             }).then(function (r) {
//                 // @ts-ignore
//                 Kakao.Auth.setAccessToken(r.data.access_token);
//                 // @ts-ignore
//                 Kakao.API.request({
//                     url: '/v2/user/me',
//                 }).then(function (response: any) {
//                     if (response.id !== undefined) {
//                         kakaoLoginComplete(response);
//                     }
//                 }).catch(function (err: any) {
//                     alert('failed to request user information: ' + JSON.stringify(err));
//                 });
//             })
//         } else {
//             // @ts-ignore
//             Kakao.Auth.logout()
//         }
//     })
// })
// const isUserHandler = () => {
//     let userPhone = userPhoneReference.current.value
// };
// const backHandler = () => {
//     setIsUser(false)
//     userPhoneReference.current.removeAttribute("readonly")
// }
// const loginHandler = () => {
//     let userPhone = userPhoneReference.current.value
//     let password = passwordReference.current.value
//
//     if (isRemember) {
//         localStorage.setItem("USER_ID", userPhone);
//     } else {
//         localStorage.removeItem("USER_ID");
//     }
//
//     if (userPhone.trim() === '') {
//         setSnackbarTxt("휴대폰번호를 입력해주세요.");
//         userPhoneReference.current.focus()
//         return;
//     }
//     const regexNotNum = /\D/;
//     const regex = /^[0-9]{11}$/;
//     if(!regexNotNum.test(userPhone)){
//         if (!regex.test(userPhone)) {
//             setSnackbarTxt('휴대폰 번호(11자리)를 바르게 입력해주세요.')
//             return;
//         }
//     }
//
//     securityHelper.login(userPhone, password, async (user: any) => {
//         if (user) {
//             await fn_loginHandlerCallback(user, navigate)
//         } else {
//             setSnackbarTxt("입력하신 비밀번호가 맞지 않습니다.")
//             passwordReference.current.removeAttribute("readonly")
//         }
//     });
// };
//
// const signUpHandler = () => {
//     let userPhone = userPhoneReference.current.value;
//     let phonNum = '';
//     const regex = /^[0-9]{11}$/;
//     if (regex.test(userPhone)) {
//         phonNum = userPhone
//     }
//     navigate('/signUp', { state: { phonNum } })
// }
// const findPwTab = (param: any) => {
//     setFindPw(param);
//     setCmpltPw(false);
// }

// const kakaoLoginComplete = (response: any) => {
//     securityHelper.loginByKakaoId(response.id, function (user: any) {
//         console.log('response: ', response.id);
//         console.log('user: ', user);
//         if (user) {
//             fn_loginHandlerCallback(user, navigate).then(r => {
//             })
//         } else {
//             // eslint-disable-next-line no-restricted-globals
//             if (confirm("가입된 내역이 존재 하지 않습니다. 회원가입을 진행하시겠습니까?")) {
//                 setTimeout(() => navigate('/signUp', { state: { kakaoId: response.id } }), 1500);
//                 // TODO: 카카오 사용자 회원가입
//             } else {
//                 // @ts-ignore
//                 Kakao.Auth.logout()
//             }
//         }
//     })
// }
// var redirectUri = 'https://www.s100mice.com'
//var redirectUri = 'http://localhost:3000'
// const kakaoLogin = () => {
//     // @ts-ignore
//     Kakao.Auth.authorize({
//         redirectUri: redirectUri,
//         serviceTerms: 'account_email',
//         prompts: 'login',
//     })
// }
// const nfcHandler = () => {
//     alert("NFC태깅을 해주세요.")
//     // @ts-ignore
//     window.___nfc_scan(function (serialNumber) {
//         //alert(serialNumber)
//         if (serialNumber) {
//             envHelper.matchNfc(serialNumber, function (data: any) {
//                 if (data) {
//                     alert(data.name + "에 입장하셨습니다.")
//                 } else {
//                     alert("알수없는 NFC정보입니다.")
//                 }
//             })
//         } else {
//             alert("NFC태깅에 실패하였습니다.")
//         }
//     })
//     setValidArea(true)
// }

// {validArea ? <>
//         <p className='text-18 md:text-40'>휴대폰 번호</p>
//         <input ref={userPhoneReference} defaultValue={userId}
//                className='w-full h-[2.6rem] md:h-[80px] bg-back pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#868686] md:text-42 text-white placeholder:text-[#868686] placeholder:text-15 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25'
//                type='text' placeholder="‘-’ 없이 숫자만 입력해주세요." />
//         <p className='text-18 mt-15 md:text-40 md:mt-50 mb-0'>비밀번호</p>
//         <input className='w-full h-[2.6rem] md:h-[80px] bg-back pl-5 md:pl-[12px] outline-none border border-x-0 border-t-0 border-b-[0.5px] border-b-[#868686] md:text-42 text-white placeholder:text-[#868686] placeholder:text-15 placeholder:pl-7 placeholder:pb-10 md:placeholder:text-37 md:placeholder:pl-17 md:placeholder:pb-25'
//                ref={passwordReference} type='password' placeholder="비밀번호를 입력해주세요." />
//         <div className='flex items-center mt-10 md:mt-25'>
//             <input className='mr-10 md:mr-25 accent-point md:w-[40px] md:h-[40px]' onChange={(e) => setIsRemember(e.target.checked)} checked={isRemember}
//                    type='checkbox' />
//             <div className='text-17 md:text-32 text-[#d9d9d9]'>휴대폰 번호 저장</div>
//         </div>
//         <Btn clickHandler={loginHandler} login>로그인</Btn>
//         <Btn clickHandler={signUpHandler} signUp>회원가입</Btn>
//         <Btn clickHandler={() => findPwTab(true)}>비밀번호 찾기</Btn>
//         {/*<BackBtn clickHandler={backHandler} />*/}
//         {/*<img className='w-full mt-[1.25rem] md:mt-[50px] hover:cursor-pointer' src={kakaoBtn} alt='kakao' onClick={kakaoLogin} />*/}
//     </> : <div className='flex flex-col items-center justify-center'>

// </> : <>
//     <p className='text-16 md:text-40'>안녕하세요. <b>Coex</b> 입니다. 위치하신 장소를 확인하기 위해 제공되는 NFC 태깅을 해주세요
//     </p>
//     <NfcBtn clickHandler={nfcHandler} />
// </>}

// const [pccReqinfo, setPccReqinfo] = useState("");
// const [pccReturl, setPccReturl] = useState("");
// const [pccVersion, setPccVersion] = useState("");
// const [cookies, setCookie, removeCookie] = useCookies(['rememberUserId']);
// const [requestPhone, setRequestPhone] = useState("");
// const [requestIdentity, setRequestIdentity] = useState(false);

// 아이디 기억하기 : 로컬스토리지에 로그인 정보를 로컬스토리지에 저장하기
// if (isRemember) {
//   securityHelper.rememberLogin(userPhone, password, async (user: any) => {
//     if (user) {
//       await fn_loginHandlerCallback(user, navigate)
//     } else {
//       setSnackbarTxt("입력하신 비밀번호가 맞지 않습니다.")
//       passwordReference.current.removeAttribute("readonly")
//     }
//   });
// } else if (!isRemember) {

// 본인인증으로 로그인
// const pccHandler = () => {
//   var popup = window.open('', 'PCCV3Window', 'width=400, height=630, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200');
//   if (popup == null) {
//     alert(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
//   }
//   return true
// }
// // @ts-ignore
// window.___pcc_callback = function () {
//   envHelper.getPccValue(function (r: any) {
//     if(r){
//       if(requestPhone === r.phone){
//         securityHelper.loginByPhone(r.phone, function(user: any){
//           if(r){
//             fn_loginHandlerCallback(user, navigate)
//           }else{
//             window.alert("회원정보를 찾을수 없습니다.\n입력하신 번호와 동일한 번호로 본인인증을 진행해주세요.")
//           }
//         })
//       }else{
//         window.alert("입력하신 번호와 동일한 번호로 본인인증을 진행해주세요.")
//       }
//     }else{
//       window.alert("본인인증에 실패하였습니다.\n다시한번 시도해주세요.")
//     }
//   })
// }

// 본인인증으로 로그인 : 화면
// {isUser && requestIdentity &&
// <>
//   <form id="reqPCCForm" name="reqPCCForm" method="post" action="https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v2.jsp"
//         target="PCCV3Window" onSubmit={() => { return pccHandler() }}>
//     <input type="hidden" name="reqInfo" defaultValue={pccReqinfo} />
//     <input type="hidden" name="retUrl" defaultValue={pccReturl} />
//     <input type="hidden" name="verSion" defaultValue={pccVersion} />
//     <button type={"submit"} className='mt-[1.875rem] font-preLight text-13 leading-18 w-full py-[0.5rem] md:text-18 outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px]'>본인인증</button>
//   </form>
//   <BackBtn clickHandler={backHandler} />
// </>
// }

// var exp = /^[0-9]{11}|[0-9]{10}$/
// var digits = userPhone.replace(/\D/g, "");
// setRequestPhone(digits)
// var valid = exp.test(digits);
// setRequestIdentity(valid)